import { Store } from '@ngrx/store';
import * as AncillariesWithMilesActions from '@ibe/store/actions/ancillaries-with-miles.actions';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
var PayAncillariesWithMilesService = /** @class */ (function () {
    //private ancillaryToPay: { name: string, count: number, total: number, active: boolean, id?: string };
    function PayAncillariesWithMilesService(store) {
        this.store = store;
        this.ancillariesMiles = [
            {
                item: 'Seats',
                miles: 1800,
                promo: 18
            }, {
                item: 'Extra Bags',
                miles: 9000,
                promo: 20
            }, {
                item: 'Fast Track',
                miles: 8500,
                promo: 10
            }, {
                item: 'Lounge',
                miles: 8500,
                promo: 10
            }, {
                item: 'Sport Equipments',
                miles: 10000,
                promo: 30
            }, {
                item: 'Music Instruments',
                miles: 10500,
                promo: 30
            }, {
                item: 'Pets',
                miles: 9500,
                promo: 20
            }, {
                item: 'Special Meals',
                miles: 0,
                promo: 0
            }
        ];
    }
    PayAncillariesWithMilesService.prototype.setAncillaryToPay = function (value) {
        this.store.dispatch(new AncillariesWithMilesActions.PutAncillaryToPayAction(value));
    };
    PayAncillariesWithMilesService.prototype.getMilesToPayAncillary = function (ancillaryToPay, promotype) {
        if (promotype === void 0) { promotype = 'miles'; }
        if (promotype === 'miles') {
            if (ancillaryToPay) {
                var miles = this.ancillariesMiles.find(function (item) { return item.item === ancillaryToPay.name; }).miles;
                ancillaryToPay = Object.assign({}, ancillaryToPay, { total: miles * ancillaryToPay.count });
            }
        }
        else {
            if (ancillaryToPay) {
                var miles = this.ancillariesMiles.find(function (item) { return item.item === ancillaryToPay.name; }).promo;
                ancillaryToPay = Object.assign({}, ancillaryToPay, { total: miles * ancillaryToPay.count });
            }
        }
        return ancillaryToPay;
    };
    PayAncillariesWithMilesService.ngInjectableDef = i0.defineInjectable({ factory: function PayAncillariesWithMilesService_Factory() { return new PayAncillariesWithMilesService(i0.inject(i1.Store)); }, token: PayAncillariesWithMilesService, providedIn: "root" });
    return PayAncillariesWithMilesService;
}());
export { PayAncillariesWithMilesService };
